import { render } from "./ClassDialogContainer.vue?vue&type=template&id=511d269a&ts=true"
import script from "./ClassDialogContainer.vue?vue&type=script&lang=ts"
export * from "./ClassDialogContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__